'use client'

import { useServerInsertedHTML } from 'next/navigation'
import React from 'react'

import { getThemeInitScript } from '../themeInitScript'

export const InitTheme: React.FC = () => {
  useServerInsertedHTML(() => (
    <script
      dangerouslySetInnerHTML={{ __html: getThemeInitScript() }}
      id="theme-script"
    />
  ))

  return null
}
